exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orderDetailsStatus[data-v-4713be64]{position:relative;margin-left:95px;margin-right:80px}.icon-style[data-v-4713be64]{margin-left:5px;cursor:pointer;color:#f60}", ""]);

// exports
